'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

var errCode = require('err-code');

var errors = require('../errors.js');

var get = require('dlv');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var get__default = /*#__PURE__*/_interopDefaultLegacy(get);

function createPubsub(_ref) {
  var network = _ref.network,
      config = _ref.config;
  var isEnabled = get__default["default"](config || {}, 'Pubsub.Enabled', true);
  return {
    subscribe: isEnabled ? withTimeoutOption.withTimeoutOption(subscribe) : notEnabled,
    unsubscribe: isEnabled ? withTimeoutOption.withTimeoutOption(unsubscribe) : notEnabled,
    publish: isEnabled ? withTimeoutOption.withTimeoutOption(publish) : notEnabled,
    ls: isEnabled ? withTimeoutOption.withTimeoutOption(ls) : notEnabled,
    peers: isEnabled ? withTimeoutOption.withTimeoutOption(peers) : notEnabled
  };

  function subscribe(_x, _x2) {
    return _subscribe.apply(this, arguments);
  }

  function _subscribe() {
    _subscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(topic, handler) {
      var options,
          _yield$network$use,
          libp2p,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
              _context.next = 3;
              return network.use(options);

            case 3:
              _yield$network$use = _context.sent;
              libp2p = _yield$network$use.libp2p;
              return _context.abrupt("return", libp2p.pubsub.subscribe(topic, handler, options));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _subscribe.apply(this, arguments);
  }

  function unsubscribe(_x3, _x4) {
    return _unsubscribe.apply(this, arguments);
  }

  function _unsubscribe() {
    _unsubscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(topic, handler) {
      var options,
          _yield$network$use2,
          libp2p,
          _args2 = arguments;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              options = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
              _context2.next = 3;
              return network.use(options);

            case 3:
              _yield$network$use2 = _context2.sent;
              libp2p = _yield$network$use2.libp2p;
              libp2p.pubsub.unsubscribe(topic, handler, options);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _unsubscribe.apply(this, arguments);
  }

  function publish(_x5, _x6) {
    return _publish.apply(this, arguments);
  }

  function _publish() {
    _publish = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(topic, data) {
      var options,
          _yield$network$use3,
          libp2p,
          _args3 = arguments;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              options = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};
              _context3.next = 3;
              return network.use(options);

            case 3:
              _yield$network$use3 = _context3.sent;
              libp2p = _yield$network$use3.libp2p;

              if (data) {
                _context3.next = 7;
                break;
              }

              throw errCode__default["default"](new Error('argument "data" is required'), 'ERR_ARG_REQUIRED');

            case 7:
              _context3.next = 9;
              return libp2p.pubsub.publish(topic, data);

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _publish.apply(this, arguments);
  }

  function ls() {
    return _ls.apply(this, arguments);
  }

  function _ls() {
    _ls = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var options,
          _yield$network$use4,
          libp2p,
          _args4 = arguments;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              options = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
              _context4.next = 3;
              return network.use(options);

            case 3:
              _yield$network$use4 = _context4.sent;
              libp2p = _yield$network$use4.libp2p;
              return _context4.abrupt("return", libp2p.pubsub.getTopics());

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _ls.apply(this, arguments);
  }

  function peers(_x7) {
    return _peers.apply(this, arguments);
  }

  function _peers() {
    _peers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(topic) {
      var options,
          _yield$network$use5,
          libp2p,
          _args5 = arguments;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              options = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
              _context5.next = 3;
              return network.use(options);

            case 3:
              _yield$network$use5 = _context5.sent;
              libp2p = _yield$network$use5.libp2p;
              return _context5.abrupt("return", libp2p.pubsub.getSubscribers(topic));

            case 6:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    return _peers.apply(this, arguments);
  }
}

var notEnabled = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            throw new errors.NotEnabledError('pubsub not enabled');

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function notEnabled() {
    return _ref2.apply(this, arguments);
  };
}();

exports.createPubsub = createPubsub;